import data from "../../../../../src/ActionMenu/ActionMenu.docs.json";
import { Box, Avatar, ActionList, ActionMenu } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Box,
  Avatar,
  ActionList,
  ActionMenu,
  React
};